import { createStore, applyMiddleware } from 'redux'
// import { composeWithDevTools } from 'redux-devtools-extension'
import thunk from 'redux-thunk'
import createRootReducer from './root-reducer'

let store

export const getStore = () => {
  return store
}

export default (initialState) => {
  // const composeEnhancers = composeWithDevTools({
  //   name: 'Ascension'
  // })

  const rootReducer = createRootReducer()

  store = createStore(
    rootReducer,
    initialState,
    applyMiddleware(thunk)
    // composeEnhancers(applyMiddleware(thunk))
  )

  if (module.hot) {
    module.hot.accept(() => {
      const nextRootReducer = require('./root-reducer').default
      store.replaceReducer(nextRootReducer)
    })
  }

  return store
}
